/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Generic_Users_EndpointInputs */



/**
* | output |
* | --- |
* | "User management" |
*
* @param {Scim_Setup_Generic_Users_EndpointInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_generic_users_endpoint = /** @type {((inputs?: Scim_Setup_Generic_Users_EndpointInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Generic_Users_EndpointInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerverwaltung")
	return /** @type {LocalizedString} */ ("User management")
});